/**
 * The pieces the rounded dialogs of the exercise detail share: the window, the
 * title and the sentences under it, and the two kinds of action. A dialog
 * spreads them into its own `makeStyles` and overrides a key where its layout
 * differs.
 */
const stiliDialog = (theme) => ({
  paper: {
    borderRadius: theme.shape.dialogRadius,
  },
  titolo: {
    ...theme.typography.dialogTitle,
    overflowWrap: 'anywhere',
  },
  testo: {
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
  },
  secondario: {
    borderRadius: theme.shape.controlRadius,
    fontWeight: 500,
    padding: theme.spacing(1, 2.5),
    textTransform: 'none',
  },
  primario: {
    borderRadius: theme.shape.controlRadius,
    boxShadow: 'none',
    // The brand's text colour, picked to read on its primary: white would
    // vanish on a light brand.
    color: theme.palette.text.main,
    fontWeight: 600,
    padding: theme.spacing(1, 3),
    textTransform: 'none',
  },
});

export default stiliDialog;
